import { LoanFGTS } from 'src/presentation/pages'

export const makeLoanFGTS = () => <LoanFGTS />
